import React from "react";
import SideMenu, { SideMenuLink } from "@amzn/meridian/side-menu";
import { useAppDispatch, useAppSelector } from "src/store/store";
import { setIsSideMenuOpen } from "src/store/layoutSlice";

const LandingSideMenu = () => {
  const { isSideMenuOpen } = useAppSelector((state) => state.layout);
  const dispatch = useAppDispatch();
  return (
    <SideMenu
      type="overlay"
      open={isSideMenuOpen}
      onClose={() => dispatch(setIsSideMenuOpen(false))}
    >
      <SideMenuLink selected={true} onClick={() => {}}>
        Navigation Item 1
      </SideMenuLink>
    </SideMenu>
  );
};

export default LandingSideMenu;
